module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "s_main"
  }, [_c('div', {
    staticClass: "s_container"
  }, [_c('article', {
    staticClass: "s_left"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.config.cfgDesc)
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "30px auto"
    }
  }, [_c('button', {
    staticStyle: {
      "cursor": "pointer",
      "border": "0px",
      "width": "200px",
      "height": "35px",
      "background-color": "#141651",
      "color": "#ffffff",
      "font-size": "16px",
      "margin-right": "50px"
    },
    on: {
      "click": _vm.tosub
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "cursor": "pointer",
      "border": "0px",
      "width": "200px",
      "height": "35px",
      "background-color": "#141651",
      "color": "#ffffff",
      "font-size": "16px"
    },
    on: {
      "click": _vm.tostatus
    }
  }, [_vm._v("Abstract    Status")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149f10a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paper/overview.vue
// module id = 770
// module chunks = 10